const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const SEPERATOR = require('../../utils/constants');
const { decode } = require('base-64');
const apiConfig = require('../../api-config');
const { Base64 } = require('js-base64');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {

    init(metaData) {
      const url = getUrl('upload/initialize');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };

      const body = {
        adminUserId: parsedMetaData.qs.userId,
        language: parsedMetaData.portfolio.language
      };

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },


    search(inputParam, metaData) {

      const url = getUrl('contract/search');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };

      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const bpId = params[0];

      const body = {
        adminUserId:  parsedMetaData.qs.userId,
        language: parsedMetaData.portfolio.language,
        criteria: {
          bpId: bpId,
        }
      };

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    finalize(base64Contracts, base64DataObj, metaData) {

      const arrayOfSelectedContracts = JSON.parse(Base64.decode(base64Contracts));
      const ObjofData = JSON.parse(Base64.decode(base64DataObj));
      const url = getUrl('upload/finalize');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const body = {
        adminUserId: parsedMetaData.qs.userId,
        language: parsedMetaData.portfolio.language,
        contracts: arrayOfSelectedContracts,
        docMetadata: ObjofData,
        acceptVersionId: 1
      };

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    finalizeChunk( base64DataObj, metaData) {

      const ObjofData = JSON.parse(decode(base64DataObj));
      const url = getUrl('documents/chunks/finalize');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const body = {
        adminUserId: parsedMetaData.qs.userId,
        language: parsedMetaData.portfolio.language,
        fileReference: ObjofData,
      };

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },



    uploadHistory(inputParam, metaData) {

      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const sortColumn = params[0];
      const order = params[1];
      const bpId = JSON.parse(decode(params[2]));
      const contract = JSON.parse(decode(params[3]));
      const name = JSON.parse(decode(params[4]));
      const isSelf = params[5]
      const fromDate = params[6];
      const toDate = params[7];
      const decodePageObj = JSON.parse(decode(params[8]));

      const url = getUrl('upload/history');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const body = {
        adminUserId:  parsedMetaData.qs.userId,
        sortColumn: sortColumn,
        order: order,
        filter: {
          bpId: bpId,
          contract: contract,
          name: name,
          isSelf,
          dateRange: {
            "from": fromDate,
            "to": toDate
          }
        },
        page: decodePageObj
      };

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    download(inputParam, metaData) {

      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const docId = params[0];
      let docusafeDocId = params[1];
      if(docusafeDocId === "null"){
        docusafeDocId = null
      }
      const contract = params[2]
      const url = getUrl('download');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };

      const body = {
        adminUserId:  parsedMetaData.qs.userId,
        docMetadataId: docId,
        docusafeDocId,
        contract
      };

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

  };
}



module.exports = apiFactory;
